import api from "@/lib/api";

// Starts a background chapter job and polls its status (these AI jobs can outlast proxy timeouts).
async function runChapterJob(base, body, failMsg) {
  await api.post(base, body);
  const started = Date.now();
  while (Date.now() - started < 10 * 60 * 1000) {
    await new Promise((r) => setTimeout(r, 3000));
    let data;
    try { ({ data } = await api.get(`${base}/status`)); } catch { continue; }
    if (data.status === "done") return data;
    if (data.status === "error" || data.status === "none") {
      const err = new Error(data.error || failMsg);
      err.response = { data: { detail: data.error || failMsg } };
      throw err;
    }
  }
  throw Object.assign(new Error("timeout"), { response: { data: { detail: "This is taking unusually long — check the chapter in a minute" } } });
}

export const rewriteChapter = (projectId, chapterId, body) =>
  runChapterJob(`/projects/${projectId}/chapters/${chapterId}/rewrite`, body, "Couldn't rewrite this chapter — please try again");

export const tidyChapter = (projectId, chapterId) =>
  runChapterJob(`/projects/${projectId}/chapters/${chapterId}/tidy`, {}, "Tidy failed — please try again");

export const gorePassChapter = (projectId, chapterId) =>
  runChapterJob(`/projects/${projectId}/chapters/${chapterId}/gore-pass`, {}, "Gore pass failed — please try again");

export const polishChapter = (projectId, chapterId, body) =>
  runChapterJob(`/projects/${projectId}/chapters/${chapterId}/polish`, body, "Polish failed — please try again");
